<template>
    <div class="w-full flex flex-row justify-center h-screen relative overflow-hidden parallax">
        <!--<img class="bg-visualz w-full h-screen absolute" src="../assets/bg-1.png">-->
        <img v-bind:style="activeStyle" class="absolute z-20 letter-a" src="../assets/A.svg">
        <img v-bind:style="activeStyle2" class="absolute w-64 z-20 letter-v overflow-hidden" src="../assets/V.svg">
        <img v-bind:style="activeStyle3" :class="[appear2]" class="absolute w-64 z-30 letter-oval-one"
             src="../assets/oval1.svg">
        <img :class="[appear]" class="absolute w-64 z-10 letter-oval-two" src="../assets/oval2.svg">
        <a v-scroll-to="{ el:'.scrolltender', offset: -200 }" class="z-50 absolute bg-2020 cursor-pointer">
            <img class="absolute w-32 pin-r mt-8 z-40" src="../assets/2020logo.svg" alt="">
        </a>
        <a v-scroll-to="'.srollmain'" class="bg-logo absolute z-50">
            <img src="../assets/visualz_white.svg" class="cursor-pointer w-48 h-16 z-50">
        </a>
        <div class="flex justify-center w-full z-40">
            <div class="self-center font-fira text-white mid-slogan">
                <h1 class="font-fira text-5xl font-hairline"><span class="italic">design</span><br>
                    <span class="font-fira rotate inline-block text-5xl font-normal mt-2">for</span> your <span
                            class="inline-block text-5xl font-normal">business</span></h1>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['scrollPos'],
  data () {
    return {
      appear: [],
      appear2: []
    }
  },
  computed: {
    activeStyle () {
      return `transform: translate(-${this.scrollPos / 10}px, ${this.scrollPos}px);`
    },
    activeStyle2 () {
      return `transform: translate(${this.scrollPos / 10}px, ${this.scrollPos}px);`
    },
    activeStyle3 () {
      return `transform: translate(-${this.scrollPos / 10}px, ${this.scrollPos / 10}px);`
    }
  },
  methods: {
    gg () {
      this.appear.push('rollIn')
      this.appear2.push('rollIn2')
    }
  }

}
</script>
<style lang="scss" scoped>
    .mid-slogan {
        margin-left: 40px;
        margin-top: 180px;
        padding-right: 100px;
        @media (min-width: 768px) {
            padding-right: 200px;
            margin-top: 0;
            margin-left: 0;
        }
    }

    .rotate {
        transform: rotate(-90deg);
    }

    .bg-2020 {
        width: 100px;
        top: 20px;
        right: 50px;
        transition: transform .1s ease-in;
        @media (max-width: 576px) {
            top: -10px;
            right: 25px;
            width: 75px;
        }
    }
    .bg-2020:hover {
        transform: scale(1.1);
    }

    .bg-logo {
        top: 50px;
        left: 50px;
        @media (max-width: 576px) {
            top: 25px;
            left: 25px;
        }
        @media (max-width: 768px) {

        }
        @media (max-width: 992px) {

        }
        @media (max-width: 1200px) {

        }

    }

    .parallax {
        background: url("../assets/background_blue.svg");
        background-attachment: fixed;
        background-position: bottom;
        background-repeat: no-repeat;
        background-size: cover;
        top: 0;
        bottom: 100px;
    }

    .svg {
        viewbox: 88 200 1800 1700;
    }

    .bg-visualz {
        object-fit: cover;

    }

    .letter-a {
        filter: drop-shadow(10px 30px 15px rgba(0, 0, 0, 0.7));
        width: 80%;
        max-height: 100%;
        bottom: 5%;
        right: -21%;
        @media (max-width: 576px) {
        }
        @media (max-width: 768px) {
        }
        @media (max-width: 992px) {

        }
        @media (max-width: 1200px) {
            /*bottom: 60%;*/
        }
    }

    .letter-v {
        filter: drop-shadow(10px 30px 15px rgba(0, 0, 0, 0.7));
        width: 60%;
        bottom: 30%;
        left: -15%;
        @media (max-width: 576px) {

        }
        @media (max-width: 768px) {
            width: 80%;
            left: -20%;
            bottom: 50%;
        }
        @media (max-width: 992px) {

        }
        @media (max-width: 1200px) {

        }

    }

    .letter-oval-one {
        filter: drop-shadow(-15px -15px 15px rgba(0, 0, 0, 0.7));
        width: 40%;
        right: -19%;
        bottom: 44%;
        @media (max-width: 576px) {
        }
        @media (max-width: 768px) {
        }
        @media (max-width: 992px) {

        }
        @media (max-width: 1200px) {

        }

    }

    .letter-oval-two {
        filter: drop-shadow(30px -15px 15px rgba(0, 0, 0, 0.5));
        width: 30%;
        left: -9%;
        bottom: 8%;
        @media (max-width: 576px) {

        }
        @media (max-width: 768px) {
            width: 50%;
            bottom: 30%;
        }
        @media (max-width: 992px) {

        }
        @media (max-width: 1200px) {

        }

    }

    @keyframes rollIn {
        0% {
            opacity: 0;
            transform: translateX(-100%) rotate(-120deg);
        }
        100% {
            opacity: 1;
            transform: translateX(0px) rotate(0deg);
        }
    }

    @keyframes rollIn2 {
        0% {
            opacity: 0;
            transform: translateX(100%) rotate(-120deg);
        }
        100% {
            opacity: 1;
            transform: translateX(0px) rotate(0deg);
        }

    }

    .rollIn {
        transform-origin: center;
        animation-timing-function: ease-in-out;
        animation-name: rollIn;
        animation-duration: 2s;
        animation-fill-mode: both;
    }

    .rollIn2 {
        transform-origin: center;
        animation-timing-function: ease-in-out;
        animation-name: rollIn2;
        animation-duration: 2s;
        animation-fill-mode: both;
    }

</style>



// WEBPACK FOOTER //
// src/components/Hero.vue